export { Comppoints } from './Comppoints';
